<div class="vector-map__toolbar-item">
    <label class="label" for="<%= name %>">
        <input type="checkbox" id="<%= name %>" name="map_control_<%= name %>" data-map-layer="<%= name %>" value="<%= name %>"
        <% if(checked) { %>checked<% } %>>
        <i class="icon icon-bullet-01 feature-<%= name %>"></i>
        <%= description %>
    </label>
</div>
